<template>
  <div v-if="multiSectionList && multiSectionList.length" key="vod_multi_section" class="multi-section-wrap">
    <div v-for="(sectionInfo) in multiSectionList" :key="sectionInfo.title + 'vod_container'" class="multi-section-container">
      <DynamicSectionLoader :section-info="sectionInfo" v-on-display="sectionInfo"></DynamicSectionLoader>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import { onDisplay } from '@/common/directives'
import { enableBodyScroll } from '@/common/util/ui.utils'
export default {
  name: 'Vod',
  components: { DynamicSectionLoader },
  directives: {
    onDisplay
  },
  computed: {
    ...mapGetters(['multiSectionList'])
  },
  created () {
    enableBodyScroll()
  }
}
</script>
<style scoped>
</style>
